import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sunIcon", "moonIcon"]

  connect() {
    // Check for saved theme preference or default to light mode
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      this.enableDarkMode()
    } else {
      this.enableLightMode()
    }
  }

  toggle() {
    if (document.documentElement.classList.contains('dark')) {
      this.enableLightMode()
    } else {
      this.enableDarkMode()
    }
  }

  enableDarkMode() {
    document.documentElement.classList.add('dark')
    localStorage.setItem('theme', 'dark')
    this.updateIcons()
  }

  enableLightMode() {
    document.documentElement.classList.remove('dark')
    localStorage.setItem('theme', 'light')
    this.updateIcons()
  }

  updateIcons() {
    const isDark = document.documentElement.classList.contains('dark')
    if (this.hasSunIconTarget && this.hasMoonIconTarget) {
      if (isDark) {
        this.sunIconTarget.classList.remove('hidden')
        this.moonIconTarget.classList.add('hidden')
      } else {
        this.sunIconTarget.classList.add('hidden')
        this.moonIconTarget.classList.remove('hidden')
      }
    }
  }
}
